<ng-select
  [items]="availableItems"
  [(ngModel)]="selectedItems"
  (ngModelChange)="onModelChange()"
  [placeholder]="placeholder"
  [maxSelectedItems]="5"
  [clearable]="true"
  [addTag]="true"
  [multiple]="true"
  [isOpen]="false"
  [searchable]="true"
>
</ng-select>
